/**
 * Curated primary colors offered to networks, anchored on the Communo brand
 * ramps (`src/theme/tokens/colors.ts`) so any picked value stays on-brand.
 */
export const NETWORK_COLOR_PALETTE = [
  '#FFDE59', // yellow.400 — the Communo yellow
  '#C99A2E', // yellow.600
  '#1A66FF', // blue.500
  '#6FA0FF', // blue.300
  '#163896', // blue.700
  '#FF3399', // pink.500
  '#A21162', // pink.700
  '#E38F3F', // orange.400
  '#A74F00', // orange.600
  '#A855F7', // purple.500
  '#7E22CE', // purple.700
  '#2D3748', // gray.700
] as const

export const getRandomNetworkColor = (): string =>
  NETWORK_COLOR_PALETTE[
    Math.floor(Math.random() * NETWORK_COLOR_PALETTE.length)
  ]
